import React from 'react';

export default function Card({ title, subtitle, children }) {
  return (
    <div className="card">
      {title ? <h2 className="card-title">{title}</h2> : null}
      {subtitle ? <p className="card-subtitle">{subtitle}</p> : null}
      {children}
    </div>
  );
}


